import React, { forwardRef } from "react";

import { Button } from "@braze/beacon-core";

import { useClickTool } from "@components/AgenticAi/hooks/useClickTool";

import type { BrazeButtonProps } from "./types";

export const BrazeButton = forwardRef<HTMLButtonElement, BrazeButtonProps>(
  ({ onClick, operatorLabel, operatorRequiresApproval = "yes", disabled, ...props }, ref) => {
    const { setRef, operatorDescription } = useClickTool<HTMLButtonElement>({
      forwardedRef: ref,
      idPrefix: "braze-button",
      name: "click_button",
      description: "Click a button",
      subject: "Button",
      operatorLabel,
      operatorRequiresApproval,
      disabled,
    });

    return (
      <Button
        aria-label={operatorLabel}
        {...props}
        onClick={onClick}
        data-operator-description={operatorDescription}
        disabled={disabled}
        ref={setRef}
      />
    );
  }
);
